'use client';

import { useEffect, useState } from 'react';

/**
 * Which of the given section ids is currently "in view", judged against a
 * band across the upper part of the viewport. Distinct from `useInViewOnce`:
 * this keeps watching and moves as the visitor scrolls.
 *
 * Without IntersectionObserver the first id stays active, which is a true
 * enough answer for a rail whose links still work as plain anchors.
 */
export function useActiveSection(ids: readonly string[], rootMargin = '-20% 0px -70% 0px'): string {
  const [active, setActive] = useState(ids[0] ?? '');

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) setActive(entry.target.id);
        }
      },
      { rootMargin },
    );
    for (const id of ids) {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    }
    return () => observer.disconnect();
  }, [ids, rootMargin]);

  return active;
}
